/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanSteps/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconSteps from 'DesignSystem/Svgs/TysiaIconSteps/index'
import TysiaProgress from 'DesignSystem/TysiaProgress/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanSteps({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/PlanSteps"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let rulesetAllowedStepsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData = 'plan'
let aggregateData = fromAggregate.includes(rulesetAllowedStepsValueData, constantData)
let rulesetAllowedStepsValueData1 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData1 = 'sign'
let aggregateData1 = fromAggregate.includes(rulesetAllowedStepsValueData1, constantData1)
let rulesetAllowedStepsValueData2 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData2 = 'down_payment'
let aggregateData2 = fromAggregate.includes(rulesetAllowedStepsValueData2, constantData2)
let rulesetDownpaymentPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'downpayment_payment_methods',
})
let rulesetAllowedStepsValueData3 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData3 = 'auto_pay'
let aggregateData3 = fromAggregate.includes(rulesetAllowedStepsValueData3, constantData3)
let rulesetAutodraftPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'autodraft_payment_methods',
})
let rulesetAllowedStepsValueData4 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData4 = 'schedule'
let aggregateData4 = fromAggregate.includes(rulesetAllowedStepsValueData4, constantData4)
  return (<React.Fragment
>
<div
  data-testid="PlanSteps.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="PlanSteps.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-ZepajS': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-2-ZepajS': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-3-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PlanSteps.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-ZepajS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSteps
  viewPath={`${viewPath}/TysiaIconSteps`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 textTransform="uppercase"
 text="TREATMENT PLAN STEPS"
/>
</div>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../EditSteps'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../EditSteps'))}
 text="Edit"
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="PlanSteps.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-1-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZepajS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaProgress
  viewPath={`${viewPath}/TysiaProgress`}
 data="ruleset.allowed_steps"
 data="'plan'"
 aggregate="/Data/aggregate.js includes"
 disabled={!aggregateData}
 text="Select Plan"
/>
<TysiaProgress
  viewPath={`${viewPath}/TysiaProgress`}
 data="ruleset.allowed_steps"
 data="'sign'"
 aggregate="/Data/aggregate.js includes"
 disabled={!aggregateData1}
 text="Sign Contract"
/>
<TysiaProgress
  viewPath={`${viewPath}/TysiaProgress`}
 data="ruleset.allowed_steps"
 data="'down_payment'"
 aggregate="/Data/aggregate.js includes"
 disabled={!aggregateData2}
 data="ruleset.downpayment_payment_methods"
 tags={rulesetDownpaymentPaymentMethodsValueData}
 text="Pay Downpayment"
/>
<TysiaProgress
  viewPath={`${viewPath}/TysiaProgress`}
 data="ruleset.allowed_steps"
 data="'auto_pay'"
 aggregate="/Data/aggregate.js includes"
 disabled={!aggregateData3}
 data="ruleset.autodraft_payment_methods"
 tags={rulesetAutodraftPaymentMethodsValueData}
 text="Setup Autodraft"
/>
<TysiaProgress
  viewPath={`${viewPath}/TysiaProgress`}
 isLast={true}
 data="ruleset.allowed_steps"
 data="'schedule'"
 aggregate="/Data/aggregate.js includes"
 disabled={!aggregateData4}
 text="Schedule appointment"
/>
</div>
</div>
{children}
</React.Fragment>)
}